<h1 mat-dialog-title>Añadir nuevo usuario</h1>

<mat-dialog-content [formGroup]="user_form" class="add-user-dialog-content">
  <div class="container-fluid px-0">
    <h2 class="dialog-section">Datos personales</h2>
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
          <mat-label>Nombre</mat-label>
          <input type="text" matInput formControlName="name" />
          @if (user_form.get('name')?.hasError('required')) {
            <mat-error>El nombre es obligatorio.</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
          <mat-label>Apellidos</mat-label>
          <input type="text" matInput formControlName="surnames" />
          @if (user_form.get('surnames')?.hasError('required')) {
            <mat-error>Los apellidos son obligatorios.</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
          <mat-label>Correo electrónico</mat-label>
          <input type="email" matInput formControlName="email" />
          @if (user_form.get('email')?.hasError('required')) {
            <mat-error>El correo electrónico es obligatorio.</mat-error>
          }
          @if (user_form.get('email')?.hasError('email')) {
            <mat-error>El correo electrónico no es válido.</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
          <mat-label>Sexo</mat-label>
          <mat-select formControlName="sex" panelWidth="auto">
            <mat-option value="M">Masculino</mat-option>
            <mat-option value="F">Femenino</mat-option>
          </mat-select>
          @if (user_form.get('sex')?.hasError('required')) {
            <mat-error>El sexo es obligatorio.</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
          <mat-label>Fecha de nacimiento</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="birthday" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (user_form.get('birthday')?.hasError('required')) {
            <mat-error>La fecha de nacimiento es obligatoria.</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline" class="add-user-dialog-field">
          <mat-label>Teléfono móvil</mat-label>
          <input type="tel" matInput placeholder="+34.666 555 444" formControlName="phone" />
          <mat-icon matSuffix>phone</mat-icon>
          <mat-hint>Formato deseado: +xx.xxx xxx xxx</mat-hint>
          @if (user_form.get('phone')?.hasError('required')) {
            <mat-error>El teléfono es obligatorio.</mat-error>
          }
          @if (user_form.get('phone')?.hasError('pattern')) {
            <mat-error>El formato del teléfono no es válido.</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <h2 class="dialog-section">Acceso</h2>
    <div class="row">
      <div class="col-12 col-lg-8">
        <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
          <mat-label>Contraseña / Notificación</mat-label>
          <mat-select formControlName="password_option" panelWidth="auto">
            <mat-option [value]="PasswordOptionEnum.WITHOUT_PASSWORD_NOTIFY">Sin contraseña y notificar por correo</mat-option>
            <mat-option [value]="PasswordOptionEnum.WITHOUT_PASSWORD_NO_NOTIFY">Sin contraseña y sin notificar</mat-option>
            <mat-option [value]="PasswordOptionEnum.WITH_PASSWORD">Con contraseña</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if (selected_password_option() === PasswordOptionEnum.WITH_PASSWORD) {
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="add-user-dialog-field">
            <mat-label>Contraseña</mat-label>
            <input type="password" matInput formControlName="password" />
            @if (user_form.get('password')?.hasError('required')) {
              <mat-error>La contraseña es obligatoria.</mat-error>
            } @else if (user_form.get('password')?.hasError('minlength')) {
              <mat-error>La contraseña debe tener al menos 8 caracteres.</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="add-user-dialog-field">
            <mat-label>Repite la contraseña</mat-label>
            <input type="password" matInput formControlName="password_confirmation" />
            @if (user_form.get('password_confirmation')?.touched && !passwords_match()) {
              <mat-error>Las contraseñas no coinciden.</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    @if (is_client_creation_locked()) {
      <h2 class="dialog-section">Rol y empresa</h2>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="role" panelWidth="auto">
              @for (role of company_user_roles(); track role.id) {
                <mat-option [value]="role.slug">{{ role.name }}</mat-option>
              }
            </mat-select>
            @if (user_form.get('role')?.hasError('required')) {
              <mat-error>El rol es obligatorio.</mat-error>
            }
          </mat-form-field>
        </div>
        @if (selected_role() === RoleSlugEnum.CLIENT) {
          <div class="col-12 col-md-6 col-lg-4">
            <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
              <mat-label>Rol de cliente</mat-label>
              <mat-select formControlName="client_role" panelWidth="auto">
                <mat-option [value]="ClientRoleEnum.BUSINESS">Business</mat-option>
                <mat-option [value]="ClientRoleEnum.DEVELOPER">Developer</mat-option>
              </mat-select>
              @if (user_form.get('client_role')?.hasError('required')) {
                <mat-error>El rol de cliente es obligatorio.</mat-error>
              }
            </mat-form-field>
          </div>
        }
        <div class="col-12 col-md-6 col-lg-4">
          <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
            <mat-label>Empresa</mat-label>
            <input matInput [formControl]="locked_company_control" readonly />
          </mat-form-field>
        </div>
      </div>
    } @else {
      <h2 class="dialog-section">Rol y departamento</h2>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="role" panelWidth="auto">
              @for (role of roles(); track role.id) {
                <mat-option [value]="role.slug">{{ role.name }}</mat-option>
              }
            </mat-select>
            @if (user_form.get('role')?.hasError('required')) {
              <mat-error>El rol es obligatorio.</mat-error>
            }
          </mat-form-field>
        </div>
        @if (selected_role() === RoleSlugEnum.CLIENT || selected_role() === RoleSlugEnum.PARTNER) {
          <div class="col-12 col-md-6 col-lg-4">
            <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
              <mat-label>{{ selected_role() === RoleSlugEnum.PARTNER ? 'Empresa colaboradora' : 'Empresa' }}</mat-label>
              <input type="text" matInput [formControl]="client_select_control" [matAutocomplete]="client_select_auto" />
              <mat-autocomplete #client_select_auto="matAutocomplete" [displayWith]="display_company_for_autocomplete" panelWidth="auto">
                @for (company of available_customers(); track company.id) {
                  <mat-option [value]="company" (click)="selectCustomer(company)">{{ company.fact_name }}</mat-option>
                }
              </mat-autocomplete>
              @if (customer_selected() !== null) {
                <button matSuffix mat-icon-button aria-label="Clear" (click)="resetCustomer()" type="button">
                  <mat-icon>close</mat-icon>
                </button>
              } @else {
                <mat-icon matSuffix>expand_more</mat-icon>
              }
              @if (user_form.get('company_id')?.hasError('required')) {
                <mat-error>La empresa es obligatoria.</mat-error>
              }
            </mat-form-field>
          </div>
          @if (selected_role() === RoleSlugEnum.CLIENT) {
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field appearance="outline" class="add-user-dialog-field nobottom">
                <mat-label>Rol de cliente</mat-label>
                <mat-select formControlName="client_role" panelWidth="auto">
                  <mat-option [value]="ClientRoleEnum.BUSINESS">Business</mat-option>
                  <mat-option [value]="ClientRoleEnum.DEVELOPER">Developer</mat-option>
                </mat-select>
                @if (user_form.get('client_role')?.hasError('required')) {
                  <mat-error>El rol de cliente es obligatorio.</mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="add-user-dialog-actions">
  <button mat-flat-button color="accent" (click)="submit()" type="submit">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>
